import * as S from './styled'
import GoldLang from '@/components/gold/GoldLang'

/** 저작권 상호명 — env(REACT_APP_COPYRIGHT) 주입, 미설정 빌드는 BRAND. */
const COPYRIGHT_NAME = process.env.REACT_APP_COPYRIGHT || process.env.REACT_APP_BRAND || ''

/**
 * ver2(gold) 모바일 하단 — gold 모바일 메인엔 하단이 없지만, 헤더에서 뺀 언어 선택을 여기 둔다
 *   (gold 는 로그인 화면·옆 메뉴에서 언어를 바꾼다). 모양은 gold 로그인 화면의 언어 상자.
 */
export default function MFooter() {
  return (
    <S.Footer>
      <GoldLang mobile />
      <S.Copy>©{new Date().getFullYear()} {COPYRIGHT_NAME ? `${COPYRIGHT_NAME} ` : ''}ALL RIGHTS RESERVED</S.Copy>
    </S.Footer>
  )
}
